/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import { Modal, Overlay } from '@entrata/portals-common/lib/components'
import { X } from '@entrata/portals-common/lib/icons'

import styled from '@emotion/styled'
import { css } from 'emotion'
import { quint } from '@entrata/portals-common/lib/styled-utils'
import { lighten, transparentize } from 'polished'

const modalStyle = css`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(71, 104, 130, 0.8);
`

const StyledDiv = styled('div')`
  max-width: calc(100vw - 64px);
  margin: 32px auto;
  background: white;
  transition: all
    ${({ duration, delay }) => `${duration}ms ${delay ? `${delay}ms` : ''}`}
    ${quint.easeInOut};

  @media only screen and (min-width: 768px) {
    max-width: calc(100vw - 128px);
  }
`

const StyledButton = styled('button')`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  color: ${({ theme }) => theme.primary.base};
  padding: 0;
  position: fixed;
  right: 24px;
  top: 24px;
  transition: all ${({ duration }) => duration}ms ${quint.easeOut};
  z-index: 10;

  &:focus,
  &:hover {
    outline: none;
    background: ${({ theme }) => lighten(0.45, theme.primary.base)};
  }
`

const transitions = {
  entering: css`
    opacity: 0;
    transform: translateY(30%);
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0%);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(-50%);
  `,
}

const closeTransitions = {
  entering: css`
    opacity: 0;
  `,
  entered: css`
    opacity: 1;
  `,
  exiting: css`
    opacity: 0;
  `,
}

const FullScreenModal = ({ duration, onClose, render, show }) => (
  <Transition in={show} mountOnEnter unmountOnExit timeout={duration}>
    {status => {
      const delay = /^enter/.test(status) ? 100 : 0
      return (
        <Modal className={modalStyle} timeout={duration} onClose={onClose}>
          {({ containerProps, titleId }) => (
            <React.Fragment>
              <Overlay
                color={transparentize(0.05, '#fff')}
                duration={duration}
                status={status}
              />
              <StyledDiv
                className={transitions[status]}
                duration={duration - delay}
                delay={delay}
                {...containerProps}
              >
                {render({ titleId })}
              </StyledDiv>
              <StyledButton
                className={closeTransitions[status]}
                duration={duration}
                onClick={onClose}
              >
                <X />
              </StyledButton>
            </React.Fragment>
          )}
        </Modal>
      )
    }}
  </Transition>
)

FullScreenModal.propTypes = {
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  show: PropTypes.bool,
}

FullScreenModal.defaultProps = {
  duration: 500,
}

export default FullScreenModal
